import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-datepicker', 'selectDate', 'Выберите дату');
Labels.set('ui-datepicker', 'selectedDate', 'Выбранная дата');
Labels.set('ui-datepicker', 'close', 'Закрыть');
Labels.set('ui-datepicker', 'clear', 'Очистить поле');
Labels.set(
    'ui-datepicker',
    'invalidFormatHint',
    'Используйте формат даты дд.мм.гггг, например 24.12.2026'
);
